import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CompanySetupService } from '../../company-setup.service';

@Component({
  selector: 'app-company-setup-social-media',
  templateUrl: './company-setup-social-media.component.html',
  styleUrls: ['./company-setup-social-media.component.scss']
})
export class CompanySetupSocialMediaComponent implements OnInit {
  socialMediaForm: FormGroup = this.companySetupService.socialMediaForm;

  constructor(private companySetupService: CompanySetupService) {}

  ngOnInit(): void {}

  get controls(): any {
    return this.socialMediaForm.controls;
  }

}
